export default __webpack_public_path__ + "static/media/3.26438d1d.png";